import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/referral_smiley.svg")